var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"row comp-useradmin-role-editor my-2"},[_c('div',{staticClass:"col-12"},[_c('sprmulti',{staticClass:"select-style",attrs:{"value":_vm.editedRoles,"title":_vm.$t('roles.rolesDropdown'),"items":_vm.possibleRoles,"placeholder":_vm.$t('roles.addRole'),"has-errors":false},on:{"input":_vm.mutate}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }